import React from 'react';

import AgreementContainer from '@totem/components/agreements/AgreementReport/AgreementContainer';
import AgreementTable from '@totem/components/agreements/AgreementReport/AgreementTable';
import IBCard from '@totem/components/ui_components/antDesignOverrides/IBCard';
import ContentLayout from '@totem/components/ui_components/page/ContentLayout';
const AgreementsPage = () => {
  return (
    <ContentLayout>
      <IBCard isCovered>
        <AgreementContainer>
          <AgreementTable />
        </AgreementContainer>
      </IBCard>
    </ContentLayout>
  );
};

export default AgreementsPage;
